export function convertToRegex(patternType: string, value: string): string {
    const escapedValue = value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    switch (patternType) {
        case "contains":
            return `.*${escapedValue}.*`;
        case "startsWith":
            return `^${escapedValue}.*`;
        case "endsWith":
            return `.*${escapedValue}$`;
        case "custom":
            // Replace * with .* for easy wildcard support
            return value.replace(/\*/g, ".*");
        default:
            return escapedValue;
    }
}

export const autoArchivePatternTypes = [
    { value: "contains", label: "Contains" },
    { value: "startsWith", label: "Starts With" },
    { value: "endsWith", label: "Ends With" },
    { value: "custom", label: "Custom" },
];
